// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TelegramIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Telegram/brand"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 12C2 6.476 6.476 2 12 2s10 4.476 10 10-4.476 10-10 10S2 17.524 2 12Zm11.895 5.36c.46.284.791.138.913-.464l1.66-8.484c.148-.743-.248-1.04-.7-.862l-9.756 4.078c-.669.283-.657.686-.114.871l1.595.54a2 2 0 0 0 1.707-.202l4.51-2.84c.101-.063.209.073.123.157l-3.213 3.149a1 1 0 0 0 .075 1.494l3.2 2.564Z",
  clipRule: "evenodd"
}));
export default TelegramIcon;